import { find } from "lodash";
import template from "./bool.html";
import cbTemplate from "./checkbox.html";
import {
	EVENT_VALUE_CHANGED,
	EVENT_REVERT_VALUES,
	EVENT_CLEAR_VALUE,
	EVENT_UNCLEAR_VALUE,
	EVENT_SET_FORM_PRISTINE
} from "constants.js";
import "./bool.less";

export class Controller {

	selection = {};

	constructor($scope, $logger, featureHelper) {
		this._scope = $scope;
		this.featureHelper = featureHelper;
		this.$logger = $logger;
	}

	$onInit() {
		this._eventBus = this.reportScope.events;
		this._unregister = this.reportFormCtrl.registerFieldController(this);

		this.initValue();

		this._eventBus.register(EVENT_REVERT_VALUES, () => {
			this.revertValue();
		}, this._scope);

		this._eventBus.register(EVENT_CLEAR_VALUE(this.field.Id), (e, params = {}) => {
			if(params.isInitializing === true && this.initialValue !== undefined) {
				return;
			}

			if(this.cleared === undefined && this.value !== undefined && params.isInitializing !== true) {
				this.cleared = this.value;
			}
			this.value = undefined;
		}, this._scope);

		this._eventBus.register(EVENT_UNCLEAR_VALUE(this.field.Id), () => {
			if(this.cleared !== undefined) {
				this.value = this.cleared;
				this.cleared = undefined;
			}
		}, this._scope);

		this._eventBus.register(EVENT_SET_FORM_PRISTINE, () => {
			this.setPristine();
		}, this._scope);
	}

	$onDestroy() {
		this._unregister();
	}

	initValue() {
		this.initialValue = find(this.values, v => v.FieldId === this.field.Id);
		if(this.reportScope.isNew && this.initialValue === undefined) {
			const hasDefaultValue = this.field.DefaultValue !== undefined;

			if(hasDefaultValue) {
				const defaultValue = this.field.DefaultValue.toLowerCase() === "true" ? true : false;
				this.initialValue = {
					FieldId: this.field.Id,
					Boolean: defaultValue
				};
				this.setValue(defaultValue);
			}
		}
		else {
			this.setValue();
		}
	}

	getCurrentValue(isApiCall = false) {
		const result = this.buildResult();

		if(result && !isApiCall && this.field.IsNotReported !== true && this.field.IsHidden !== true) {
			result.isDirty = this.value !== (this.initialValue && this.initialValue.Boolean);
		}

		return result ? [result] : [];
	}

	handleValueChanged() {
		this._eventBus.trigger(EVENT_VALUE_CHANGED(this.field.Id), {
			field: this.field,
			value: this.value
		});

		const isDirty = (this.field.visible !== false || this.initialValue !== undefined) && ((this.value !== this.initialValue?.Boolean));
		this.setFieldDirty(this.field.Id, isDirty);
	}

	selectValue(value) {
		if(this.field.isReadonly || this.field.isDisabled) {
			return;
		}

		this.value = value;
		this.handleValueChanged();
	}

	clearValue() {
		if(this.field.isReadonly || this.field.isDisabled || this.value === undefined || this.value === null) {
			return;
		}

		this.value = undefined;
		this.handleValueChanged();
	}

	revertValue() {
		this.value = this.initialValue && this.initialValue.Boolean;
	}

	setPristine() {
		this.initialValue = this.buildResult();
	}

	buildResult() {
		return this.value === null || this.value === undefined ? null : {
			FieldId: this.field.Id,
			Boolean: this.value
		};
	}

	setValue(val) {
		if(val !== undefined) {
			this.value = val;
			return;
		}

		const thisValue = find(this.values, v => v.FieldId === this.field.Id);

		if(thisValue) {
			this.value = thisValue.Boolean;
		}
	}

	getValidationStyling() {
		return this.field.hasValidationError ? "validation-error"
			: this.field.hasValidationWarning ? "validation-warning" : "";
	}
}

const boolField = angular
	.module("vesl.components.report-form.bool", [])
	.component("bool", {
		template,
		controller: Controller,
		bindings: {
			field: "<",
			values: "<",
			setFieldDirty: "="
		},
		require: {
			reportFormCtrl: "^reportForm",
			reportScope: "^^reportScope"
		}
	}).name;

const checkboxField = angular
	.module("vesl.components.report-form.checkbox", [])
	.component("checkbox", {
		template: cbTemplate,
		controller: Controller,
		bindings: {
			field: "<",
			values: "<",
			setFieldDirty: "="
		},
		require: {
			reportFormCtrl: "^reportForm",
			reportScope: "^^reportScope"
		}
	}).name;

export {
	boolField, checkboxField
};
